export const getChipColor = (value: boolean | string | undefined) => {
  const green = { primary: '#086A0D', secondary: '#81C784' };
  const yellow = { primary: '#A39414', secondary: '#FFF59D' };
  const red = { primary: '#AD4221', secondary: '#FFAB91' };
  const def = { primary: '#444444', secondary: '#EEEEEE' };

  switch (value) {
    case 'r':
      return yellow;
    case 'w':
      return red;
    case true:
      return green;
    case false:
      return red;
    default:
      return def;
  }
};
